/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
//   import config from "../config/suspendUser.config.json";
import notification from "../config/notifications.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { BLACKLIST_USERS } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface blacklistUserProps {
  ids: any;
}

export interface IBlacklistUserMethods extends IPluginMethodMap {
  getBlacklistUser(args: blacklistUserProps): Promise<any>;
}

export class BlacklistUserService implements IAgentPlugin {
  readonly methods: IBlacklistUserMethods;

  constructor() {
    this.methods = {
      getBlacklistUser: this.getBlacklistUser.bind(this),
    };
  }

  async getBlacklistUser(args: blacklistUserProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: BLACKLIST_USERS,
          variables: {
           input:{  ...args},
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.blockListUser) {
          return {
            ...res?.data?.blockListUser,
            notification: notification?.blacklistUserSuccess,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
